import { api } from '@/api'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import DetailPageHead from '@/components/DetailPageHead/index.tsx'
import { usePage } from '@/hooks'
import { IProfessionCompetition } from '@/interfaces/ProfessionCompetition'
import React, { useEffect, useState } from 'react'

const ProfessionCompetition = (): React.ReactElement => {
  const [competition, setCompetition] = useState<
  IProfessionCompetition | undefined
  >()
  const page = usePage()
  const { object, global } = page.init_state
  const { config } = global

  useEffect(() => {
    api
      .getProfessionCompetitionDetail({ id: object.id })
      .then((data) => {
        setCompetition(data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [object.id])

  return (
    <Container>
      <BackLink href={config.best_in_profession} title='Стань лучшим в профессии' />

      <DetailPageHead
        image={competition?.detail_picture}
        date={object.date_create}
        title={object.title}
        content={competition?.detail_text}
      />
    </Container>
  )
}

export default ProfessionCompetition
